import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import cpfTask from '../../../requests/tasks/net/cpfTask';
import RequestManager from '../../../requests/RequestManager';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import NetModal from './ModalNetVendors';

const classButtonInactive = 'btn btn-default close-modal ';
const reg = /^[0-9]{11}$/;
const regNumber = /^[0-9]{1,}$/;

class ModalNetVendors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    	cpf: '',
    	error: '',
    	showError: false,
    	showNetModal: false,
    };
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal("NetVendors");
  }

  save() {

  	if (!reg.test(this.state.cpf)) {
  		return this.setState({
  			showError: true,
  			error: this.showError(),
  		});
  	}

  	const cpf = this.state.cpf;
  	const cpfConfig = new cpfTask({ cpf });
    return RequestManager.addRequest(cpfConfig)
    .then(result => {
    	if (result.response.exists) {
    		// Show NET modal
    		return this.setState({
    			showNetModal: true,
    		});
    	}
    	// Redirect to normal Register
    	window.location = ClaroUrlBuilder.register();
    })
    .catch(err => {
    	const message = err.message || converter.convertApaUnicode(this.props.translations, 'bad_response_error_msg');
    	const modal = {
        modalType: 'ErrorSimple',
        props: {
          message,
          onAccept: () => {
            this.props.closeModal('ErrorSimple');
          }
        }
      };

      this.props.showModal(modal);
    });
  }

  onChange(change){
  	let newState = {};
  	newState.showError = false;

  	if(change.target.name == 'cpf' && !regNumber.test(change.target.value)) {
  		newState.error = this.showError();
  		newState.showError = true;
  	}

  	newState[change.target.name] = change.target.value;
  	this.setState(newState);
  }

  showError() {
  	return converter.convertApaUnicode(this.props.translations, 'net_cpf_no_valido', 'O número do CPF é incorreto');
  }

  render() {

  	if (this.state.showNetModal){
  		const modal = {
	      modalType: 'NetVendors',
	      props: {
	      	__forceShowFrame: true,
	      },
	    };

	    this.props.showModal(modal);
	  	return null;
  	}

  	const error = (this.state.showError) ? <div className='cpf-error'>
    	{this.state.error}
    </div> : null;

    return <Modal show={true} >
      <Modal.Header
      	style={{
          "border-top-left-radius": "6px" ,
          "border-top-right-radius": "6px",
          "background-color": "#f4f4f4",
          "color":"black",
          "font-size":"x-large "
        }}
      >
        <Button
        	className="close close-modal net-close"
        	style={{
            "color":"black",
          }}
          onClick={this.closeModal}
        >
        X
				</Button>
      </Modal.Header>
      <Modal.Body
      	className='text-center success'
      	style={{
	        "background-color": "#f4f4f4"
	      }}>

	      	<h4 className='modal-title text-center cpf-title'>
	          {converter.convertApaUnicode(this.props.translations, 'net_cpf_titulo', 'Logo você poderá aproveitar as vantagens do Claro Vídeo!')}
	        </h4>
	        <h4 className='cpf-instructions'>
	        	{converter.convertApaUnicode(this.props.translations, 'net_cpf_instrucciones', 'O primeiro passo da compra é informar seu CPF')}
	        </h4>

		      <input
		      	name='cpf'
						className="cpf-input"
						placeholder='Digite seu CPF'
						value={this.state.cpf}
						onChange={this.onChange.bind(this)}
						minLength={1}
						maxLength={11}
         />
         { error }

        </Modal.Body>
        <Modal.Footer
        	style={{
            "border-bottom-left-radius": "6px",
            "border-bottom-right-radius": "6px",
            "background-color": "#f4f4f4",
            "color":"black",
            "font-size":"large ",
            "padding-top":"0px"
          }}>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-05 text-center ">
              <Button
                style={{
                    "background-color":"gray","color":"white ", "padding":"12px 40px"}
                }
                disabled={this.state.showError}
                className={ classButtonInactive }
                onClick={this.save.bind(this)}>
                {converter.convertApaUnicode(this.props.translations, 'net_cpf_continuar', 'Continuar')}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    asset: state.asset,
    metadata:state.metadata
  };
};

const mapDispatchToProps = (dispatch) => ({
	showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalNetVendors);
